import React from "react";

const Footer = () => {
  return (
    <>
      {/* Footer */}
      <footer className="sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Copyright © Registro de la Propiedad del Cantón Ibarra 2024</span>
          </div>
        </div>
      </footer>
      {/* End of Footer */}
    </>
  );
};

export default Footer;
